import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {

  constructor(private http: HttpClient) { }

  getAllFeatures(data: any): Observable<any> {
    return this.http.post(environment.getAllFeatures, data);
  }

  createFeature(data: any): Observable<any> {
    return this.http.post(environment.createFeature, data);
  }

  updateFeature(data: any): Observable<any> {
    return this.http.post(environment.updateFeature, data);
  }

  deleteFeature(data: any): Observable<any> {
    return this.http.post(environment.deleteFeature, data);
  }

  findAndCountAllFeature(data: any): Observable<any> {
    return this.http.post(environment.findAndCountAllFeature, data);
  }
}
